/* eslint-disable react-hooks/exhaustive-deps */
// react
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useLocation } from "react-router-dom"

// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { faFileAlt } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import { AppDispatch } from "../../.."

// Kairos
import AlertComponent from "../../../components/AlertComponent"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import ComboBox from "../../../components/ComboBox"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import KadaiKentoKaigiService from "../../../service/budget/kadaiKentoKaigi/kadaiKentoKaigiService"
import {
  TWeeklyReportBusyoListGetReq,
  TWeeklyReportNinusiUriageListGetRes,
  TWeeklyReportPrintReq,
  T週報荷主売上一覧,
} from "../../../service/budget/kadaiKentoKaigi/TKadaiKentoKaigi"
import { 予算_実績メニューコード } from "../../../constant/menuCode"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import { decimalPlus } from "../../../ts/util/decimalUtil"

import { TWijmoComboBox } from "../../../type/wijmoComponents"
import { RootState } from "../../../globalStore/rootreducer"
import BusyoService from "../../../service/master/busyo/busyoService"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import dayjs from "dayjs"

/**
 * 業績会議　荷主売上一覧
 * @returns
 */
const NinusiUriageList = () => {
  const history = useHistory()
  const location = useLocation()
  const 当営業日 = useSelector((state: RootState) => state.date.eigyobiStr)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "NinusiUriageList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      sortDescriptions: [new wjCore.SortDescription("月間売上実績", false)],
      calculatedFields: {
        月間売上実績: (i: T週報荷主売上一覧) => {
          const sum =
            i.第１週売上実績 +
            i.第２週売上実績 +
            i.第３週売上実績 +
            i.第４週売上実績 +
            i.第５週売上実績 +
            i.第６週売上実績
          return sum
        },
        月間運行数: (i: T週報荷主売上一覧) => {
          const sum =
            i.第１週運行数 +
            i.第２週運行数 +
            i.第３週運行数 +
            i.第４週運行数 +
            i.第５週運行数 +
            i.第６週運行数
          return sum
        },
      },
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TWeeklyReportBusyoListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TWeeklyReportBusyoListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new KadaiKentoKaigiService().getNinusiUriageList(
        currentSearchCondition
      )
      // 週ごとのフィールドを作成して格納する
      if (res.data.filter((d) => d.週番号 === 6).length > 0) {
        set第六週フラグ(true)
      } else {
        set第六週フラグ(false)
      }
      const resData: T週報荷主売上一覧[] = []
      // 週ごとのフィールドを作成して格納する
      res.data.forEach((d: TWeeklyReportNinusiUriageListGetRes) => {
        let rowData: T週報荷主売上一覧 = {
          部所コード: d.所属部所コード ?? "",
          部所名: d.所属部所名 ?? "",
          荷主コード: d.荷主コード ?? "",
          荷主名: d.荷主名 ?? "",
          荷主略称1: d.荷主略称1 ?? "",
          第１週売上実績: 0,
          第２週売上実績: 0,
          第３週売上実績: 0,
          第４週売上実績: 0,
          第５週売上実績: 0,
          第６週売上実績: 0,
          第１週運行数: 0,
          第２週運行数: 0,
          第３週運行数: 0,
          第４週運行数: 0,
          第５週運行数: 0,
          第６週運行数: 0,
        }
        switch (d.週番号) {
          case 1:
            rowData.第１週売上実績 = d.金額
            rowData.第１週運行数 = d.運行数
            resData.push(rowData)
            break
          case 2:
            rowData.第２週売上実績 = d.金額
            rowData.第２週運行数 = d.運行数
            resData.push(rowData)
            break
          case 3:
            rowData.第３週売上実績 = d.金額
            rowData.第３週運行数 = d.運行数
            resData.push(rowData)
            break
          case 4:
            rowData.第４週売上実績 = d.金額
            rowData.第４週運行数 = d.運行数
            resData.push(rowData)
            break
          case 5:
            rowData.第５週売上実績 = d.金額
            rowData.第５週運行数 = d.運行数
            resData.push(rowData)
            break
          case 6:
            rowData.第６週売上実績 = d.金額
            rowData.第６週運行数 = d.運行数
            resData.push(rowData)
            break
          default:
            break
        }
      })
      // 部所・項目でGROUP BY的な処理
      const gridRowData = resData.reduce(
        (result: T週報荷主売上一覧[], current) => {
          const element = result.find(
            (r) => r.荷主コード === current.荷主コード
          )
          if (element) {
            element.第１週売上実績 = decimalPlus([
              element.第１週売上実績,
              current.第１週売上実績,
            ])
            element.第２週売上実績 = decimalPlus([
              element.第２週売上実績,
              current.第２週売上実績,
            ])
            element.第３週売上実績 = decimalPlus([
              element.第３週売上実績,
              current.第３週売上実績,
            ])
            element.第４週売上実績 = decimalPlus([
              element.第４週売上実績,
              current.第４週売上実績,
            ])
            element.第５週売上実績 = decimalPlus([
              element.第５週売上実績,
              current.第５週売上実績,
            ])
            element.第６週売上実績 = decimalPlus([
              element.第６週売上実績,
              current.第６週売上実績,
            ])
            element.第１週運行数 = decimalPlus([
              element.第１週運行数,
              current.第１週運行数,
            ])
            element.第２週運行数 = decimalPlus([
              element.第２週運行数,
              current.第２週運行数,
            ])
            element.第３週運行数 = decimalPlus([
              element.第３週運行数,
              current.第３週運行数,
            ])
            element.第４週運行数 = decimalPlus([
              element.第４週運行数,
              current.第４週運行数,
            ])
            element.第５週運行数 = decimalPlus([
              element.第５週運行数,
              current.第５週運行数,
            ])
            element.第６週運行数 = decimalPlus([
              element.第６週運行数,
              current.第６週運行数,
            ])
          } else {
            result.push(current)
          }
          return result
        },
        []
      )

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(gridRowData, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TWeeklyReportBusyoListGetReq = queryString.parse(
      location.search
    )
    set年月(query.年月)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TWeeklyReportBusyoListGetReq => {
    return {
      年月: 年月 ?? undefined,
      部所コード: 部所コード ?? undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TWeeklyReportBusyoListGetReq
  ) => {
    const disp年月 = dayjs(searchCondition.年月).format("YYYY/MM")
    return {
      年月: wjCore.isNullOrWhiteSpace(disp年月 ?? "") ? "" : disp年月,
      部所: 部所ItemSource?.find(
        (i) => i.部所コード === searchCondition.部所コード
      )?.部所名,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set年月("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    // ヘッダーに行追加
    // header行に一行追加
    // 追加行のみ初期化時に設定
    let extraRow = new wjGrid.Row()
    extraRow.allowMerging = true
    let columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    let columnHeaders = f.columnHeaders

    columnHeaders.columns.forEach((c, index) => {
      switch (c.binding) {
        case "荷主コード":
        case "荷主略称1":
          columnHeaders.setCellData(0, index, "荷主")
          break
        case "月間売上実績":
        case "月間運行数":
          columnHeaders.setCellData(0, index, "月間")
          break
        case "第１週売上実績":
        case "第１週運行数":
          columnHeaders.setCellData(0, index, "１週")
          break
        case "第２週売上実績":
        case "第２週運行数":
          columnHeaders.setCellData(0, index, "２週")
          break
        case "第３週売上実績":
        case "第３週運行数":
          columnHeaders.setCellData(0, index, "３週")
          break
        case "第４週売上実績":
        case "第４週運行数":
          columnHeaders.setCellData(0, index, "４週")
          break
        case "第５週売上実績":
        case "第５週運行数":
          columnHeaders.setCellData(0, index, "５週")
          break
        case "第６週売上実績":
        case "第６週運行数":
          columnHeaders.setCellData(0, index, "６週")
          break
      }
      c.allowMerging = true
      c.align = "center"
    })
  }

  /**
   * 荷主売上一覧帳票印刷処理
   */
  const printWeeklyReportNinusi = async () => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    const printCondition: TWeeklyReportPrintReq = {
      抽出条件_対象年月: 年月 ?? 当営業日,
      抽出条件_部所コード: 部所コード ?? undefined,
    }
    try {
      const res = await new KadaiKentoKaigiService({
        responseType: "blob",
      }).printWeeklyReportNinusi(printCondition)

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [年月, set年月] = useState<string | null | undefined>(当営業日)
  const [部所コード, set部所コード] = useState<
    T部所マスタ["部所コード"] | null
  >(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  // 運行場所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所isLoadEnded, set部所isLoadEnded] = useState<boolean>(false)
  const [第六週フラグ, set第六週フラグ] = useState(false)
  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)
    })
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  useEffect(() => {
    document.title = `業績会議　週報全社`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">業績会議</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>

      <Row>
        <Col>
          <Card className="w-50rem">
            <Card.Body>
              <div>
                <Link
                  to={
                    util.getMenuPath(
                      予算_実績メニューコード.業績会議_週報全社
                    )[0]
                  }
                  onClick={() =>
                    gridPageHelper.savePageConditionData(location.pathname)
                  }>
                  <Button disabled={isSearching}>業績報告</Button>
                </Link>
                <Link
                  to={
                    util.getMenuPath(
                      予算_実績メニューコード.業績会議_週報部所別
                    )[0]
                  }
                  onClick={() =>
                    gridPageHelper.savePageConditionData(location.pathname)
                  }>
                  <Button className="mx-2" disabled={isSearching}>
                    部所業績報告
                  </Button>
                </Link>
                <Button disabled={true}>荷主売上一覧</Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-60rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-8rem">
                              <MonthInput
                                id="年月"
                                placeholder="年月"
                                value={年月}
                                setValue={set年月}></MonthInput>
                            </div>
                            <ComboBox.Busyo
                              placeholder="部所"
                              isLoadEnded={部所isLoadEnded}
                              setIsLoadEnded={set部所isLoadEnded}
                              isAllSelect={true}
                              isRequired={false}
                              itemsSource={部所ItemSource}
                              listFilter={(d) => d.運行部所フラグ === 1}
                              selectedValue={部所コード}
                              setSelectedValue={(v) => {
                                set部所コード(v)
                              }}
                              ComboBox={部所ComboBox}
                              setComboBox={set部所ComboBox}></ComboBox.Busyo>
                          </div>
                        </div>
                      </Col>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                style={{ maxHeight: "auto", height: "calc(100vh - 38.5rem)" }}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                headerComponent={
                  <div>
                    <Button
                      className="btn-done"
                      disabled={
                        !gridInitialized || gridData.data.items.length === 0
                      }
                      style={{ marginLeft: "0.5rem" }}
                      onClick={(e: any) => {
                        e.stopPropagation()
                        e.preventDefault()
                        printWeeklyReportNinusi()
                      }}>
                      <FontAwesomeIcon icon={faFileAlt} />
                      荷主売上一覧印刷
                    </Button>
                  </div>
                }>
                <wjrGrid.FlexGridColumn
                  binding="荷主コード"
                  cssClass="text-start"
                  width={100}
                  header="荷主コード"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="荷主略称1"
                  cssClass="text-start"
                  width={200}
                  header="荷主名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="月間売上実績"
                  width={90}
                  cssClass="number-col"
                  header="売上実績"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="月間運行数"
                  width={90}
                  cssClass="number-col"
                  header="運行数"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第１週売上実績"
                  width={90}
                  cssClass="number-col"
                  header="売上実績"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第１週運行数"
                  width={90}
                  cssClass="number-col"
                  header="運行数"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第２週売上実績"
                  width={90}
                  cssClass="number-col"
                  header="売上実績"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第２週運行数"
                  width={90}
                  cssClass="number-col"
                  header="運行数"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第３週売上実績"
                  width={90}
                  cssClass="number-col"
                  header="売上実績"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第３週運行数"
                  width={90}
                  cssClass="number-col"
                  header="運行数"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第４週売上実績"
                  width={90}
                  cssClass="number-col"
                  header="売上実績"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第４週運行数"
                  width={90}
                  cssClass="number-col"
                  header="運行数"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第５週売上実績"
                  width={90}
                  cssClass="number-col"
                  header="売上実績"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="第５週運行数"
                  width={90}
                  cssClass="number-col"
                  header="運行数"></wjrGrid.FlexGridColumn>
                {第六週フラグ && (
                  <wjrGrid.FlexGridColumn
                    binding="第６週売上実績"
                    width={90}
                    cssClass="number-col"
                    header="売上実績"></wjrGrid.FlexGridColumn>
                )}
                {第六週フラグ && (
                  <wjrGrid.FlexGridColumn
                    binding="第６週運行数"
                    width={90}
                    cssClass="number-col"
                    header="運行数"></wjrGrid.FlexGridColumn>
                )}
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default NinusiUriageList
